class ParametroPortal {
    id: Number = 0;
    rotinaId : Number = 0;
    descricao : String = "";
    valorPadrao : String = "";
    criadoEm : Date = new Date();
    excluidoEm : Date = new Date();
    d_E_L_E_T_E : boolean = false;  
  }
  export default ParametroPortal;
  

